// Module
var code = "<div class=\"input-field mt-0\"> <div class=\"datePicker\"> <div class=\"kendo-editor-disabled\"></div> <span ng-click=\"$ctrl.showDatePicker()\"> <input class=\"form-control not-clickable\" ng-model=\"$ctrl.cell.value\" k-options=\"$ctrl.options\" id=\"{{$ctrl.id}}\" ng-change=\"$ctrl.handleOnChange(cell)\"/> </span> </div> </div> ";
// Exports
export default code;